var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT SERVICES","title":"Admission Management","description":"Review online applications and manage admission and entrance examination workflows.","count-label":"admission tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }